import BusinessDisplay from './BusinessDisplay'

export default BusinessDisplay